import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { validateRoutingNumber } from '../ValidateFunctions';
import NumberOnlyInput from "./FormInputs/NumberOnlyInput";

FormRoutingNumber.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
}

export default function FormRoutingNumber({ fieldName, fieldAttributes, focusedField, setFocusedField }) {
  const { control } = useFormContext();

  return <Controller
    name={fieldName}
    control={control}
    rules={{
      validate: value => validateRoutingNumber(value)
    }}
    render={() => (
      <NumberOnlyInput
        fieldName={fieldName}
        focusedField={focusedField}
        setFocusedField={setFocusedField}
        fieldAttributes={fieldAttributes}
      />
    )}
  />
}